"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uiMoney = _interopRequireDefault(require("ui-money"));
var _require = require('../../utils/current-plan-utils'),
  percentageFormat = _require.percentageFormat,
  getTitles = _require.getTitles;
var toDollar = function toDollar(number) {
  return new _uiMoney.default(number, 'USD').format(0);
};
var CurrentPlan = function CurrentPlan(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "current-plan col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row current-plan__summary"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "col-md-12 current-plan__title"
  }, "Your current plan"), /*#__PURE__*/_react.default.createElement("div", {
    className: "current-plan__summary__name col-md-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan-desc"
  }, "Amount financed"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan__summary__value"
  }, toDollar(props.loanAmount || props.amount))), /*#__PURE__*/_react.default.createElement("div", {
    className: "current-plan__summary__name col-md-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan-desc"
  }, getTitles(props).paymentTitle), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan__summary__value"
  }, toDollar(props.payment || props.monthlyPayment))), /*#__PURE__*/_react.default.createElement("div", {
    className: "current-plan__summary__name col-md-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan-desc"
  }, getTitles(props).periodTitle), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan__summary__value"
  }, props.introTerm || props.term)), /*#__PURE__*/_react.default.createElement("div", {
    className: "current-plan__summary__name col-md-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan-desc"
  }, getTitles(props).aprTitle), " ", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("span", {
    className: "current-plan__summary__value"
  }, props.isInterestFree ? '0%' : percentageFormat(props.intRate || props.rate, {
    isPercentage: 'true'
  }))))));
};
CurrentPlan.propTypes = {
  introTerm: _propTypes.default.string,
  term: _propTypes.default.number,
  rate: _propTypes.default.string,
  intRate: _propTypes.default.string,
  isInterestFree: _propTypes.default.bool,
  payment: _propTypes.default.string,
  monthlyPayment: _propTypes.default.string,
  loanAmount: _propTypes.default.string,
  amount: _propTypes.default.string
};
var _default = CurrentPlan;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions-v2/dist/pf-revisions.scss');